const aspireeciguk = {
    id: 'aspireeciguk',
    publicSiteName: 'Aspire eCig UK',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#f5d038',
            secondary: '#010101',
            color1: '#ffd737',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'center-logo',
            dark: false,
            sticky: false,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/aspireeciguk/favicon.ico',
        logo: '/aspireeciguk/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
}

export default aspireeciguk